
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import FormItemsOption from '@/models/forms/FormItemsOption'

@Component
export default class FormItemsModelInput extends Vue {
  @Prop() formField!: any
  @Prop(Array) formItems!: Array<FormItemsOption>
  @Prop(String) innerClass!: string
  @Prop(String) outerClass!: string
  @Prop({
    type: Boolean,
    required: false,
    default: false
  }) useFormItemContainer!: boolean

  get getFormItems () {
    return this.formItems.filter(item => !item.hide)
  }

  get dateRangeShortCuts () {
    const shortcuts: Array<Dictionary<any>> = [{
      text: 'Last week',
      onClick (picker: any) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: 'Last month',
      onClick (picker: any) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    }]
    return shortcuts
  }

  isRadioGroupType (form: FormItemsOption): boolean {
    return form.type.includes('radio') && !!form.options?.length
  }

  getValue (form: FormItemsOption): any {
    let value = form.model !== undefined ? this.formField[form.model] : this.formField[form.prop]
    if (value !== undefined && typeof value !== 'boolean' && typeof value !== 'object') value = value.toString()
    return value
  }

  getFormItemProp (form: FormItemsOption): string | undefined {
    if (!this.useFormItemContainer) return
    return form.prop
  }

  getFormItemLabel (form: FormItemsOption): string | undefined {
    if (!this.useFormItemContainer || form.useFormItemContainer === false) return
    return form.label
  }

  onRadioButtonChange (form: FormItemsOption) {
    if (!form.emitHandlerName) return
    this.$emit(form.emitHandlerName, form.value)
  }

  onEmitAction (emitName: any, value: any) {
    if (!emitName) return
    this.$emit(emitName, value)
  }
}
